import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import toast from 'react-hot-toast';

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post('/api/auth/forgot-password', { email });
      setSent(true);
      toast.success('Email inviata! Controlla la tua casella.');
    } catch (err) {
      toast.error(err.response?.data?.error || 'Errore durante la richiesta');
    }
    setLoading(false);
  };

  if (sent) {
    return (
      <div className="auth-page fade-in">
        <div className="auth-card" style={{ textAlign: 'center' }}>
          <div style={{ fontSize: 48, marginBottom: 16 }}>📧</div>
          <h2>Email inviata!</h2>
          <p style={{ color: '#6b7280', marginBottom: 24 }}>
            Se l'indirizzo <strong>{email}</strong> è associato a un account, riceverai un'email con le istruzioni per reimpostare la password.
          </p>
          <p style={{ color: '#6b7280', fontSize: 13 }}>Controlla anche la cartella spam.</p>
          <p style={{ marginTop: 24, fontSize: 14 }}>
            <Link to="/login" style={{ color: '#1a56db' }}>← Torna al login</Link>
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-page fade-in">
      <div className="auth-card">
        <h2>Password dimenticata?</h2>
        <p className="subtitle">Inserisci la tua email e ti invieremo le istruzioni per reimpostare la password.</p>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Email</label>
            <input
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              placeholder="email@azienda.it"
              required
            />
          </div>
          <button type="submit" className="btn btn-primary btn-lg" style={{ width: '100%' }} disabled={loading}>
            {loading ? 'Invio in corso...' : 'Invia istruzioni reset'}
          </button>
        </form>
        <p style={{ textAlign: 'center', marginTop: 20, fontSize: 14, color: '#6b7280' }}>
          Ricordi la password? <Link to="/login" style={{ color: '#1a56db' }}>Accedi</Link>
        </p>
      </div>
    </div>
  );
}
